import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { IntlProvider } from 'react-intl';
import { Types } from 'store/ducks/syncs';

import App from 'App/App';
import store from './store';
import './index.scss';

import SyncContextProvider from 'contexts/sync';

if (!Object.entries) {
  Object.entries = function Entries(obj) {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i); // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}

const app = (
  <IntlProvider locale={window.navigator.language}>
    <Router>
      <Provider store={store}>
        <SyncContextProvider>
          <App />
        </SyncContextProvider>
      </Provider>
    </Router>
  </IntlProvider>
);

ReactDOM.render(app, document.getElementById('root'));

serviceWorker.register({
  onUpdate: () => store.dispatch({ type: Types.UPDATE_AVAILABLE }),
});
